import { createElement } from "react";
import React from "react";
import { reactApi } from "../../fable_modules/Feliz.2.8.0/Interop.fs.js";
import { ctx as ctx_1 } from "../../Context.js";
import { some, unwrap, defaultArg, map } from "../../fable_modules/fable-library-js.4.24.0/Option.js";
import { isNullOrWhiteSpace } from "../../fable_modules/fable-library-js.4.24.0/String.js";
import { strIContains } from "../../Shared/Shared.js";
import { API_Customer_OrdersWith } from "../../Shared/Urls.js";
import { toString } from "../../fable_modules/fable-library-js.4.24.0/Types.js";
import { Auto_generateBoxedDecoderCached_Z6670B51, Auto_generateBoxedDecoder_Z6670B51 } from "../../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { Order_$reflection } from "../../Shared/ApiDataTypes.js";
import { obj_type, array_type } from "../../fable_modules/fable-library-js.4.24.0/Reflection.js";
import { testRedirect, extraCoders } from "../../Promises.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { FetchError } from "../../fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { Result_MapError, FSharpResult$2 } from "../../fable_modules/fable-library-js.4.24.0/Result.js";
import { Helper_fetch, Helper_withContentTypeJson, Helper_withProperties } from "../../fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { Types_RequestProperties } from "../../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { keyValueList } from "../../fable_modules/fable-library-js.4.24.0/MapUtil.js";
import { singleton, cons, ofArray, empty } from "../../fable_modules/fable-library-js.4.24.0/List.js";
import { toString as toString_1 } from "../../fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { Auto_generateBoxedEncoderCached_437914C6 } from "../../fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { fromString } from "../../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { createObj, uncurry2 } from "../../fable_modules/fable-library-js.4.24.0/Util.js";
import { MuiHelpers_createElement } from "../../fable_modules/Feliz.MaterialUI.5.13.7-alpha.8/Mui.fs.js";
import { Typography } from "@mui/material";
import { filterBox } from "../../Orders/Orders.js";
import { Components_Searchbar_25F45B5E } from "../../Components/Searchbar.js";
import { debounce as debounce_1 } from "../../Utils.js";
import { Orders_Table_1967F6FE } from "../../Orders/Table.js";

export function Dashboard_OrdersTable_Z37302880(dashboard_OrdersTable_Z37302880InputProps) {
    let elems_2, elems_1, elems;
    const customerId = dashboard_OrdersTable_Z37302880InputProps.customerId;
    const groupId = dashboard_OrdersTable_Z37302880InputProps.groupId;
    const ctx = reactApi.useContext(ctx_1);
    const patternInput = reactApi.useState(false);
    const anyStatus = patternInput[0];
    const patternInput_1 = reactApi.useState(false);
    const withTickets = patternInput_1[0];
    const patternInput_2 = reactApi.useState("");
    const searchTerm = patternInput_2[0];
    const patternInput_3 = reactApi.useState(undefined);
    const timer = reactApi.useRef(0);
    const filtered = map((array) => array.filter((order) => {
        if (isNullOrWhiteSpace(searchTerm)) {
            return true;
        }
        else {
            return strIContains(searchTerm, `${order.Company.Abbr}${order.Number}`);
        }
    }), patternInput_3[0]);
    const dependencies = [groupId, customerId, withTickets, anyStatus];
    reactApi.useEffect(() => {
        let properties_2;
        const url = API_Customer_OrdersWith([["with-ticket", toString(withTickets)], ["any-status", toString(anyStatus)]], customerId);
        let pr_2;
        let pr_1;
        const decoder = Auto_generateBoxedDecoder_Z6670B51(array_type(Order_$reflection()), undefined, undefined);
        const data_1 = undefined;
        const caseStrategy_2 = undefined;
        const extra_2 = extraCoders;
        try {
            const properties_3 = Helper_withProperties(undefined, (properties_2 = ofArray([new Types_RequestProperties(0, ["GET"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString_1(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_2), unwrap(extra_2))(data_1_1))]), properties_2), data_1), properties_2)));
            const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Helper_fetch(url, properties_3).then((_arg) => {
                let response_1, decoder_1_1;
                return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(array_type(Order_$reflection()), unwrap(caseStrategy_2), unwrap(extra_2))), PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (response_1.text().then((_arg_1) => {
                    let matchValue;
                    return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
                })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
            }))));
            pr_1 = (pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])])))));
        }
        catch (exn) {
            pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
        }
        pr_2 = (pr_1.then((result_1) => Result_MapError(testRedirect, result_1)));
        pr_2.then((res) => {
            if (res.tag === 0) {
                patternInput_3[1](res.fields[0]);
            }
            else {
                console.error(some("[CustomerDashboard] Error fetching orders"), res.fields[0]);
            }
        });
    }, dependencies);
    return createElement("div", createObj(singleton((elems_2 = [createElement("div", createObj(ofArray([["style", {
        display: "flex",
        alignItems: "center",
    }], (elems_1 = [createElement("div", createObj(ofArray([["style", {
        flexGrow: 1,
    }], (elems = [MuiHelpers_createElement(Typography, [["variant", "h4"], ["noWrap", true], ["children", ctx.Locale.t("Pages.OpenOrders")]])], ["children", reactApi.Children.toArray(Array.from(elems))])]))), filterBox(ctx.Locale.t("Orders.WithTicket"), withTickets, (isChecked) => {
        patternInput_1[1](isChecked);
    }), filterBox(ctx.Locale.t("Orders.IncludeClosed"), anyStatus, (isChecked_1) => {
        patternInput[1](isChecked_1);
    }), createElement("div", {
        style: {
            flexBasis: 220 + "px",
        },
        children: createElement(Components_Searchbar_25F45B5E, {
            placeholder: ctx.Locale.t("Search"),
            onChange: (ev) => {
                const str_2 = ev.target.value;
                const trimmed = str_2.trim();
                debounce_1(500, timer, () => {
                    patternInput_2[1](trimmed);
                });
            },
        }),
    })], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), createElement(Orders_Table_1967F6FE, {
        orders: unwrap(filtered),
        rowsPerPage: 5,
    })], ["children", reactApi.Children.toArray(Array.from(elems_2))]))));
}

